export default __webpack_public_path__ + "static/media/Pattern_04.125364bd.png";